module.exports = __webpack_public_path__ + "img/yellow_s.5aa25931.svg";